import { useFlags } from '@mint-lib/routing-context';

export const usePlatformCampaignLevelFF = () => {
  const ff = useFlags('@mint/arm', ['platformCampaignLevel']);

  return ff.platformCampaignLevel.enabled;
};
